module.exports = __webpack_public_path__ + "img/ep1.de012c16.jpg";